import axios from './axios';

export const pointApi = {
  terminales: () => axios.get('/pagos/point/terminales').then(r => r.data),
  porBoleta: id => axios.get(`/pagos/point/boletas/${id}/cobros`).then(r => r.data),
  crear: (id, data) => axios.post(`/pagos/point/boletas/${id}/cobros`, data).then(r => r.data),
  consultar: id => axios.get(`/pagos/point/cobros/${id}`).then(r => r.data),
  cancelar: id => axios.post(`/pagos/point/cobros/${id}/cancelar`).then(r => r.data),
};
